/*
 *   File : order.js
 *   Author : https://evoqins.com
 *   Description : Order card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom components
import { useNavigate } from 'react-router-dom';
import { Icon } from '../Icon';

//Custom components

const OrderCard = ({
    order,
    handleClick,
    handleCloseModal,
    labelClassName = 'e-text-dark-gray e-font-weight-400 line-height-16px'
}) => {

    const navigate = useNavigate();



    const showTooltip = labelClassName.includes("truncate-second-line");


    return (
        <div className={` all-orders h-100 e-border-1px-taupe-gray e-bg-white border-radius-16 pe-3 py-3 transition`}>
            <div className='d-flex align-items-center justify-content-between'>
                <span className='px-4 text-center ribbon-bg e-text-arsenic e-alt-font e-font-12 e-font-weight-600'>
                    {order.type}
                </span>
                {/* <span className='e-text-arsenic e-alt-font e-font-12 e-font-weight-400'>
                    {order.order_date}
                </span> */}
            </div>
            <div className='d-flex align-items-center justify-content-between ps-3 pt-3'>
                <div className='d-flex gap-1 align-items-center '>
                    <p className='mb-0 e-text-arsenic e-alt-font e-font-12 e-font-weight-400 '>
                        Rayi Order ID:
                    </p>
                    <p className={`mb-0 e-alt-font e-font-12 e-font-weight-600 `}>
                        {order.order_display_id}
                    </p>
                </div>
                <span className='e-text-arsenic e-alt-font e-font-12 e-font-weight-400'>
                    {order.order_date}
                </span>
            </div>


            <div className='d-flex justify-content-between align-items-start'>
                <p className={`${labelClassName} ps-3  margin-12px-bottom  e-alt-font e-font-14  mt-3`}>
                    {order.product_name || order.product}
                </p>
                <span className='e-font-16 mt-3 margin-12px-bottom  e-font-weight-600 e-text-dark-gray line-height-18px'>
                    {order.amount_text || ""}
                </span>
            </div>


            <div className='ps-3 d-flex justify-content-between align-items-center  gap-3'>

                <div className='d-flex gap-1 align-items-center'>
                    <p className='mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                        Order:
                    </p>
                    <p className={`mb-0 ${order.order_status === "Success" || order.order_status === "Successful" ? "e-text-success" : order.order_status === "Failed" ? "e-text-carmine-pink" : order.order_status === "Partially Success" ? "e-text-bleu-de-france" : "e-text-princeton-orange"} e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                        {order.order_status}
                    </p>
                </div>
                {
                    order.order_status !== "In progress" &&
                    <div className='d-flex gap-1 align-items-center'>
                        <p className='mb-0 e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>
                            Payment:
                        </p>
                        {order.payment_status ?
                            <p className={`mb-0 ${order.payment_status === "Success" || order.payment_status === "Successful" ? "e-text-success" : order.payment_status === "Failed" ? "e-text-carmine-pink" : order.order_status === "Partially Success" ? "e-text-bleu-de-france" : "e-text-princeton-orange"} e-alt-font e-font-14 e-font-weight-600 line-height-20px`}>
                                {order.payment_status}
                            </p>
                            :
                            <span className='e-text-arsenic e-alt-font e-font-14 e-font-weight-400 line-height-16px'>-</span>
                        }
                        <Icon icon="proceed"
                            className="cursor-pointer ps-1 margin-2px-bottom"
                            size={18}
                        />
                    </div>
                }
            </div>


        </div>
    )
}

export default OrderCard;


OrderCard.default = {
    labelClassName: 'e-text-dark-gray e-font-weight-400 line-height-16px',
};